@defer {
<div class="mi-table relative">
  @if(headerWidget){
  @if (moduleName === 'order' && isOrderHistory) {
  <div class="flex justify-content-end manage-pagination w-full">
    <p-paginator
      [first]="first2"
      [rows]="rows2"
      [totalRecords]="totalRecords"
      (onPageChange)="onPageChange2($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first}-{last} of {totalRecords}"
      [showPageLinks]="false"
      [showFirstLastIcon]="false">
    </p-paginator>
  </div>
  } @else {
  <div class="flex mi-filter-container z-10 w-full">
    <div class="flex flex-wrap justify-content-center pl-2">
      <div class="flex-1 flex justify-content-end mr-2">
        <span class="p-input-icon-left">
          <i class="pi search-icon relative left-20 cursor-pointer"
            [ngClass]="{ 'pi-search': !searchValue, 'pi-times': searchValue }"
            (click)="clearSearch()"></i>
          <input class="width-200 search-filter" type="text" pInputText
            (input)="onSearch($event)"
            [placeholder]="'lbl_search' | translate"
            [(ngModel)]="searchValue" />
        </span>
      </div>

      @if (!exclude_modules.includes(moduleName)) {
      @if(filterList && filterList?.length > 0) {
      <app-quick-filter-form [fields]="filterList?.slice(0, filterSize)"
        [moduleName]="moduleName ? moduleName : uniqueId"
        class="relative mr-2"
        [attributeLabels]="attributeLabels"
        [attributeValues]="filterValues"
        [defaultValues]="defaultFilterValues"
        (onValueChange)="onFilterValueChange(false, $event)">
      </app-quick-filter-form>
      }

      @if(filterList && filterList.length > filterSize) {
      <app-filter-box [filterList]="filterList?.slice(filterSize)"
        [moduleName]="moduleName ? moduleName : uniqueId"
        [show]="show"
        [position]="position"
        [selectedFilterCount]="selectedFilterCount"
        [filterAttributeLabels]="attributeLabels"
        [attributeValues]="filterValues"
        class="filter-box-div"
        (click)="onFiltersPopup()"
        (onValueChange)="onFilterValueChange(true, $event)"
        (onToggleOverLay)="show = false"
        isFilterBox="true">
      </app-filter-box>

      <p-button
        label="{{'filters_lbl' | translate}}"
        icon="{{miIcons.TEXT_ALIGN}} inline-block wh-13 relative left-5 top-1"
        class="filter-secondary mr-2"
        [badge]="selectedFilterCount > 0 && selectedFilterCount"
        badgeClass="filter-btn"
        (click)="showFilterDialog('right')">
      </p-button>
      }
      } @else {
      @if(filterList && filterList?.length > 0) {
      <app-quick-filter-form [fields]="filterList?.slice(0, 4)"
        [moduleName]="moduleName"
        class="relative mr-2"
        [attributeLabels]="attributeLabels"
        [defaultValues]="defaultFilterValues"
        (onValueChange)="onFilterValueChange(false, $event)">
      </app-quick-filter-form>
      }
      }

      @if (selectedFilterCount > 0) {
      <button pButton [label]="'clear_all' | translate"
        (click)="clearFilter()"
        class="mr-2 bg-white text-primary border-none cursor-pointer clear-btn">
      </button>
      }
    </div>

    <div class="flex-1 flex align-items-center justify-content-end manage-pagination">
      <p-paginator
        [first]="first2"
        [rows]="rows2"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange2($event)"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}-{last} of {totalRecords}"
        [showPageLinks]="false"
        [showFirstLastIcon]="false">
      </p-paginator>

      <div class="flex justify-content-end">
        <app-per-page-columns [columns]="columns"
          [collectionOfColumns]="collectionOfColumns"
          (onToggleManageColumn)="onToggleManageColumn()"
          (itemPerPage)="updateRows($event)"
          [itemsPerPage]="itemsPerPage">
        </app-per-page-columns>
      </div>
    </div>
  </div>
  }

  @if((!EXCLUDE_CHECKBOX?.includes(entityName) && !EXCLUDE_CHECKBOX?.includes(staticEntity)) || isBulkSelection) {
  @if (selectedRows?.length>0 && bulkSelectionsItems?.length>0) {
  <div class="mt-2 pb-2 border-bottom-1 border-200 leave-list">
    <p-button icon="pi pi-chevron-down" [badge]="selectedRows.length" badgeClass="badge-selected-row"
      class="mr-2 button-with-icon cursor-pointer" severity="secondary" (click)="actions.toggle($event)"
      [label]="'lbl_actions' | translate"></p-button>
    <p-menu #actions [model]="bulkSelectionsItems" [popup]="true" appendTo="body"></p-menu>
    <button pButton [label]="'clear_selection' | translate" (click)="clearSelected()"
      class="mr-2 bg-white text-primary border-none cursor-pointer clear-btn"></button>
  </div>
  }
  }

  <div class="table-content-wrapper">

    <p-table [scrollable]="true" [scrollHeight]=" skipScroll ? '100%' : 'calc(100vh - 176px)'"
      [columns]="selectedColumns"
      [value]="data" [loading]="isLoading" [tableStyle]="{ 'min-width': '100rem' }" [(selection)]="selectedRows"
      selectionMode="multiple" (selectionChange)="selectionChange()" (onRowSelect)="onRowSelect($event)"
      [customSort]="true" (onSort)="setSortColumnSortOrder($event)" #dt1>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @if((!EXCLUDE_CHECKBOX?.includes(entityName) && !EXCLUDE_CHECKBOX?.includes(staticEntity) && !isDeletedTab) ||
          isBulkSelection) {
          <th>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          }
          @for (col of columns; track col.field; let idx = $index) {
          @if (idx === 0) {
          <th [pSortableColumn]="col.field" class=" align-items-center" [pSortableColumnDisabled]="!col.isSortable"
            (click)="sortData(col)">
            {{ col.header }}
            @if (col.isSortable) {
            <p-sortIcon [field]="col.field"></p-sortIcon>
            }
          </th>
          }
          @if (idx !== 0) {

          <th [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.isSortable"
            (click)="sortData(col)">
            {{ col.header }}
            @if (col.isSortable) {
            <p-sortIcon [field]="col.field"></p-sortIcon>
            }
          </th>

          }
          }
          <th translate alignFrozen="right" pFrozenColumn>
            <!-- lbl_action -->
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
        @if (data?.length > 0) {
        <tr [pSelectableRow]="rowData" (mouseover)="rowMouseOver(rowData)" (mouseout)="rowMouseOut(rowData)"
          [ngClass]="{'deleted-row': rowData.deleted}">
          @if((!EXCLUDE_CHECKBOX?.includes(entityName) && !EXCLUDE_CHECKBOX?.includes(staticEntity) && !isDeletedTab) ||
          isBulkSelection) {
          <td style="width: 4rem">
            <p-tableCheckbox [value]="rowData" (click)="toggleCheckbox($event)"
              [disabled]="rowData.deleted"></p-tableCheckbox>
          </td>
          }
          @for (col of columns; track col) {
          <td style="min-width:200px" class="ellipsis">
            <div>
              @switch (col.attributeCode) {
              @case ('email') {
              <div>
                <a [href]="'mailto:' + rowData[col.field]"> {{ rowData[col.field] }}</a>
              </div>
              }
              @case ('emailAddress') {
              <div>
                <div class="flex vertical-align-middle">
                  <div> {{rowData?.email}}</div>
                </div>
              </div>
              }
              @case ('contactNumber'){
              <div>
                <div class="flex vertical-align-middle">
                  <div>
                    {{
                    rowData?.countryCode && rowData?.contactNumber
                    ? (rowData?.countryCode?.startsWith('+')
                    ? rowData?.countryCode + '-' + rowData?.contactNumber
                    : '+' + rowData?.countryCode + '-' + rowData?.contactNumber)
                    : (rowData?.contactNumber
                    ? rowData?.contactNumber
                    : (rowData?.countryCode
                    ? '+' + rowData?.countryCode + '-' + rowData?.contactNumber
                    : '-'))
                    }}
                  </div>
                </div>
              </div>
              }

              @case ('product_code'){
              <div>
                {{ rowData.product_code}}
              </div>
              <div class="text-sm">
                {{rowData.entity_created_at ? (metaDataService.formatDateTimeOnTZ(rowData.entity_created_at, 'MMM D,
                YYYY,
                h:mm A')) : '--'}}
              </div>
              }

              @case ('protocol_code'){
              <div>
                {{ rowData.protocol_code}}
              </div>
              <div class="text-sm">
                {{rowData.entity_created_at ? (metaDataService.formatDateTimeOnTZ(rowData.entity_created_at, 'MMM D,
                YYYY,
                h:mm A')) : '--'}}
              </div>
              }

              @case('protocol_id'){
              <div pTooltip="{{ rowData.protocol_name }}"
                [tooltipDisabled]="rowData.protocol_name?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData.protocol_name?.length > 30 ? rowData.protocol_name?.substring(0, 30) + '...' :
                rowData.protocol_name
                }}
              </div>
              }

              @case('site_id'){
              <div pTooltip="{{ rowData.site_name }}" [tooltipDisabled]="rowData.site_name?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData.site_name?.length > 30 ? rowData.site_name?.substring(0, 30) + '...' : rowData.site_name
                }}
              </div>
              }

              @case ('pack_type'){
              <div>
                @for (item of rowData[col.field] | keyvalue; track item.key) {
                {{ item.value }}
                }
              </div>
              }

              @case ('storage'){
              <div>
                @for (item of rowData[col.field] | keyvalue; track item.key) {
                {{ item.value }}
                }
              </div>
              }

              @case ('delivery_days'){
              <div>
                @if(rowData[col.field] && rowData[col.field].length > 0) {
                @if(rowData.delivery_time_from && rowData.delivery_time_to) {
                {{ formatDeliveryDays(rowData[col.field]) }} {{ formatDeliveryTime(rowData.delivery_time_from,
                rowData.delivery_time_to) }}
                } @else {
                {{ formatDeliveryDays(rowData[col.field]) }}
                }
                } @else {
                --
                }
              </div>
              }

              @case ('default_address'){
              @for (item of rowData[col.field] | keyvalue; track item.key) {
              <div [ngClass]="{'active-box': item.key === 'Yes'}"
                class="border-x-1 border-y-1 border-gray-300 p-2 surface-ground surface-border flex align-items-center justify-content-center border-round-xl max-w-min">
                {{ item.value }}
              </div>
              }
              }


              @case ('location_type'){
              <div class="flex align-items-center gap-2">
                @for (item of rowData[col.field] | keyvalue; track item.key) {
                {{ item.value }}
                }
              </div>
              }
              @case('changeReviewStatus'){
              <app-change-review-status [attributeValues]="rowData"
                (click)="stopPropagation($event)"></app-change-review-status>
              }

              @case('createdAt') {
              <div>{{ rowData.loggedAt ? (metaDataService.formatDateTimeOnTZ(rowData.loggedAt, 'DD MMM YYYY, h:mm A')) :
                '--' }}</div>
              }

              @case('expiry_date'){
              <div>{{ rowData.expiry_date ? (getFormattedDate(rowData.expiry_date)) :
                '--' }}</div>
              }


              @case('date_of_dispatch'){
              <div>{{ rowData.date_of_dispatch ? (metaDataService.formatDateTimeOnTZ(rowData.date_of_dispatch, 'DD MMM
                YYYY')) :
                '--' }}</div>
              }

              @case('received_date'){
              <div>{{ rowData.received_date ? (metaDataService.formatDateTimeOnTZ(rowData.received_date, 'DD MMM
                YYYY')) :
                '--' }}</div>
              }

              @case('expected_delivery_date'){
              <div>
                {{rowData[col.field] ? (metaDataService.formatDateTimeOnTZ(rowData[col.field], 'DD MMM
                YYYY')) : '--'}}
              </div>
              }

              @case('entityType') {
              <div>
                {{ getEntityLabel(rowData.entityCode) }}
              </div>
              }

              @case('eventStatus') {
              <div>
                {{ rowData.statusCode === 200 ? 'Success' : 'Error' }}
              </div>
              }

              @case ('start_date'){
              <div>
                {{rowData[col.field] ? (metaDataService.formatDateTimeOnTZ(rowData[col.field], 'MMM D, YYYY')) : '--'}}
              </div>
              }

              @case('end_date'){
              <div>
                {{rowData[col.field] ? (metaDataService.formatDateTimeOnTZ(rowData[col.field], 'MMM D, YYYY')) : '--'}}
              </div>
              }
              @case('commencement_date'){
              <div>
                {{rowData[col.field] ? (metaDataService.formatDateTimeOnTZ(rowData[col.field], 'MMM D, YYYY')) : '--'}}
              </div>
              }
              @case('next_visit'){
              <div>
                {{rowData[col.field] ? (metaDataService.formatDateTimeOnTZ(rowData[col.field], 'MMM D, YYYY')) : '--'}}
              </div>
              }


              @case('site_address_line_1'){
              <div
                pTooltip="{{ formatSiteAddress(rowData) }}"
                [tooltipDisabled]="formatSiteAddress(rowData)?.length <= 30"
                tooltipPosition="top">
                {{ formatSiteAddress(rowData)?.length > 30
                ? formatSiteAddress(rowData)?.substring(0, 30) + '...'
                : formatSiteAddress(rowData) }}
              </div>
              }

              @case('spn_addr_line_1'){
              <div
                pTooltip="{{ formatSponsorAddress(rowData) }}"
                [tooltipDisabled]="formatSponsorAddress(rowData)?.length <= 30"
                tooltipPosition="top">
                {{ formatSponsorAddress(rowData)?.length > 30
                ? formatSponsorAddress(rowData)?.substring(0, 30) + '...'
                : formatSponsorAddress(rowData) }}
              </div>
              }

              @case('changeReason'){
              <div pTooltip="{{ rowData[col.field] }}" [tooltipDisabled]="rowData[col.field]?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData[col.field]?.length > 30 ? rowData[col.field]?.substring(0, 30) + '...' : rowData[col.field]
                }}
              </div>
              }

              @case('site_delivery_address_id'){
              <div
                pTooltip="{{ formatAddress(rowData) }}"
                [tooltipDisabled]="formatAddress(rowData)?.length <= 30"
                tooltipPosition="top">
                {{ formatAddress(rowData)?.length > 30
                ? formatAddress(rowData)?.substring(0, 30) + '...'
                : formatAddress(rowData) }}
              </div>
              }

              @case('address_line_1'){
              <div
                pTooltip="{{ formatAddress(rowData) }}"
                [tooltipDisabled]="formatAddress(rowData)?.length <= 30"
                tooltipPosition="top">
                {{ formatAddress(rowData)?.length > 30
                ? formatAddress(rowData)?.substring(0, 30) + '...'
                : formatAddress(rowData) }}
              </div>
              }

              @case('changeReason'){
              <div>
                {{rowData[col.field]}}
              </div>
              }
              @case('entity_created_at'){
              <div>
                @if (rowData[col.field]) {
                <span>{{metaDataService.formatDateTimeOnTZ(rowData[col.field], 'DD MMM YYYY')}}, </span>
                <b>{{metaDataService.formatDateTimeOnTZ(rowData[col.field], 'hh:mm A')}}</b>
                } @else {
                --
                }
              </div>
              }
              @case('activity_status'){
              <div class="flex align-items-center">
                <span [ngClass]="{
                  'mi-og': true,
                  'wh-16': true,
                  'nav-icon-products': rowData[col.field]?.toLowerCase().includes('added'),
                  'basic-circle-checked': rowData[col.field]?.toLowerCase().includes('approved'),
                  'file-chart-file': rowData[col.field]?.toLowerCase().includes('placed'),
                  'icon-notes': rowData[col.field]?.toLowerCase().includes('generated'),
                  'mi-off_outline_close mi-red-og': rowData[col.field]?.toLowerCase().includes('rejected'),
                }">
                </span> <span [ngClass]="{'text-red-500': rowData[col.field]?.toLowerCase().includes('rejected'), 
              'text-green-500': !rowData[col.field]?.toLowerCase().includes('rejected')}">
                  {{rowData[col.field]}}</span>
              </div>
              }

              @case('order_acceptance_status'){
              <div class="flex align-items-center gap-2">
                @for (item of rowData[col.field] | keyvalue; track item.key) {
                <div class="border-round-md status-box" [ngClass]="{
                    'active': item.key?.toLowerCase() === 'accept',
                    'rejected': item.key?.toLowerCase() === 'return',
                  }">
                  <div class="flex align-items-center gap-2"> {{ item.value }} </div>
                </div>
                }
              </div>
              }

              @case('order_status'){
              <div class=" flex align-items-center gap-2">
                @for (item of rowData[col.field] | keyvalue; track item.key) {
                <div class="border-round-md status-box" [ngClass]="{
                    'new_order': item.key?.toLowerCase() === 'new_order',
                    'rejected': item.key?.toLowerCase() === 'order_rejected',
                    'completed': item.key?.toLowerCase() === 'order_completed',
                    'order_received': item.key?.toLowerCase() === 'delivery_completed',
                    'to_be_invoiced': item.key?.toLowerCase() === 'to_be_invoiced',
                    'delivery_completed': item.key?.toLowerCase() === 'delivery_completed',
                    'order_partially_confirmed': item.key?.toLowerCase() === 'order_partially_confirmed',
                    'delivery_completed': item.key?.toLowerCase() === 'order_dispatched',
                    'order_completed': item.key?.toLowerCase() === 'order_completed',
                    'partially_received': item.key?.toLowerCase() === 'order_partially_received',
                    'back_order': item.key?.toLowerCase() === 'back_order',
                    'awaiting_confirmation': item.key?.toLowerCase() === 'awaiting_order_receive_confirmation',
                    'return_order': item.key?.toLowerCase() === 'return_order',
                  }">
                  <div class="flex align-items-center gap-2"> {{ item.value }} </div>
                  @if(item?.date_of_dispatch) {
                  <div class="flex align-items-center gap-2"><span translate>lbl_expected_date</span>
                    {{ item?.date_of_dispatch ? metaDataService.formatDateTimeOnTZ(item?.date_of_dispatch,
                    'DD-MM-YYYY')
                    :
                    '--' }} </div>
                  }
                  @if(item.key === "ORDER_DISPATCHED") {
                  <label class="delivery-date" translate>lbl_expected_date</label>
                  <span class="delivery-date">{{rowData?.expected_delivery_date ?
                    metaDataService.formatDateTimeOnTZ(rowData?.expected_delivery_date, 'DD-MM-YYYY') :
                    '--' }} </span>
                  }
                  @if(item.key === "BACK_ORDER" || item.key === "RETURN_ORDER") {
                  <div class="flex align-items-center gap-2">
                    <label class="delivery-date" translate>lbl_parent_order</label>
                    <span class="delivery-date">
                      {{ rowData?.order?.[0]?.order_number }}
                    </span>
                  </div>
                  }

                </div>
                }
              </div>
              }
              @case('protocol_entity_id'){
              <div pTooltip="{{ rowData.protocol_name }}"
                [tooltipDisabled]="rowData.protocol_name?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData.protocol_name?.length > 30 ? rowData.protocol_name?.substring(0, 30) + '...' :
                rowData.protocol_name }}
              </div>
              }

              @case('product_entity_id'){
              <div pTooltip="{{ rowData.product_name }}"
                [tooltipDisabled]="rowData.product_name?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData.product_name?.length > 30 ? rowData.product_name?.substring(0, 30) + '...' :
                rowData.product_name }}
              </div>
              }

              @case('site_entity_id'){
              <div pTooltip="{{ rowData.site_name }}"
                [tooltipDisabled]="rowData.site_name?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData.site_name?.length > 30 ? rowData.site_name?.substring(0, 30) + '...' : rowData.site_name }}
              </div>
              }


              <!-- @case('order_id'){
              <div>
                {{rowData.site_name}}
              </div>
              } -->

              @case('invoiceDownload') {
              <span (click)="invoiceDownload(rowData)"><i
                  class="{{miIcons.DOWNLOAD}} inline-block wh-20 relative"></i></span>
              }

              @case('received_by'){
              <div pTooltip="{{ rowData[col.field] }}"
                [tooltipDisabled]="rowData[col.field]?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData[col.field]?.length > 30 ? rowData[col.field]?.substring(0, 30) + '...' : rowData[col.field]
                }}
              </div>
              }

              @case('updated_by'){
              <div>
                @if (rowData[col.field]) {
                <b>{{rowData.actionUserDetails?.actionTaken}}</b> <span> ({{rowData.actionUserDetails?.role}})</span>
                } @else {
                --
                }
              </div>
              }
              @case('can_order'){
              <div class="flex align-items-center gap-2">
                <span class="border-round-md status-box" [ngClass]="{
                        'active': rowData?.can_order,
                        'inactive': !rowData?.can_order
                      }"> {{ rowData?.can_order ? 'Yes' : 'No' }} </span>
              </div>
              }

              @case('allotted_budget'){
              <div>
                {{rowData[col.field] | currency:'USD'}}
              </div>
              }
              @case('unit_cost'){
              <div>
                {{rowData[col.field] | currency:'USD'}}
              </div>
              }
              @case('unit_price'){
              <div>
                {{rowData[col.field] | currency:'USD'}}
              </div>
              }

              @case('total_amount'){
              <div>
                {{rowData[col.field] | currency:'USD'}}
              </div>
              }

              @case('user_parent'){
              <div>
                {{rowData.parentName || '--'}}
              </div>
              }

              @case('order_product_ids'){
              <div>
                {{rowData[col.field]?.length || 0}}
              </div>
              }

              @case('upload_document'){
              <div class="flex align-items-center">
                @if(rowData.upload_document?.[0]) {
                <button
                  class="p-button p-button-text p-button-sm flex align-items-center justify-content-center cursor-pointer"
                  pTooltip="Download document" tooltipPosition="top"
                  (click)="downloadDocument($event, rowData._docSignedUrl)">
                  <i class="pi pi-download" style="font-size:1rem"></i>
                </button>
                } @else {
                --
                }
              </div>
              }

              @default {
              @if(rowData[col.field] && statusColsArray.includes(col.attributeCode)) {
              <!-- @if(col.attributeCode === 'protocol_status' || col.attributeCode === 'purchase_order_status') { -->
              <div class="flex align-items-center gap-2">
                @for (item of rowData[col.field] | keyvalue; track item.key) {
                <div class="border-round-md status-box" [ngClass]="{
                        'active': item.key?.toLowerCase() === 'active',
                        'inactive': item.key?.toLowerCase() === 'inactive',
                        'archived': item.key?.toLowerCase() === 'archive',
                        'draft': item.key?.toLowerCase() === 'draft',
                        'completed': item.key?.toLowerCase() === 'completed',
                        'running': item.key?.toLowerCase() === 'running', 
                        'paused': item.key?.toLowerCase() === 'paused',
                        'stopped': item.key?.toLowerCase() === 'stopped',
                        'requested': item.key?.toLowerCase() === 'requested',
                        'rejected': item.key?.toLowerCase() === 'rejected',
                        'on-trial': item.key?.toLowerCase() === 'on trial',
                        'off-trial': item.key?.toLowerCase() === 'off trial',
                      }"> {{ item.value }}

                  @if((item.key?.toLowerCase() === "on trial" &&
                  rowData.pause_from_date && rowData.pause_to_date) || (item.key?.toLowerCase() === "paused" &&
                  rowData.pause_from_date && rowData.pause_to_date)) {
                  <div class="flex align-items-center gap-2">
                    <label class="delivery-date" translate>patient.lbl_pause</label>:
                    <span class="delivery-date">
                      {{rowData.pause_from_date ? (metaDataService.formatDateInTZ(rowData.pause_from_date)) : '--'}}
                      <span translate>patient.lbl_to</span>

                      {{rowData.pause_to_date ? (metaDataService.formatDateInTZ(rowData.pause_to_date)) : '--'}}
                    </span>
                  </div>
                  }
                </div>
                }
              </div>
              <!-- } @else { 
                  <div class="flex align-items-center gap-2"> 
                    @for (item of rowData[col.field] | keyvalue; track item.key) {
                      <span class="status-dot" [ngClass]="{
                        'bg-green-500': item.key?.toLowerCase() === 'active',
                        'bg-red-500': item.key?.toLowerCase() === 'inactive'
                      }"></span>   {{ item.value }}
                    }
                  </div>
                } -->
              } @else if (rowData[col.field]) {
              <div pTooltip="{{ rowData[col.field] }}"
                [tooltipDisabled]="rowData[col.field]?.toString()?.length <= 30"
                tooltipPosition="top">
                {{ rowData[col.field]?.length > 30 ? rowData[col.field]?.substring(0, 30) + '...' : rowData[col.field]
                }}
              </div>
              } @else {
              <div>--</div>
              }
              }
              }
            </div>
          </td>
          }
          <!-- @if(rowData?.showRowMenu) { -->
          <td alignFrozen="right" pFrozenColumn>
            @if(rowItems?.length > 0){
            <p-button [style.visibility]="rowData?.showRowMenu ? 'visible' : 'hidden'"
              icon="{{miIcons.MORE_HORIZONTAL}} block wh-24"
              class="flex cursor-pointer height-40-px width-46 more-horizontal-icon" styleClass="p-button-secondary"
              (click)="setCurrentRow(rowData);menu.toggle($event);"
              severity="secondary"></p-button>
            <p-menu #menu styleClass="menu-width" [model]="rowItems" [popup]="true" appendTo="body"></p-menu>

            }
          </td>
          <!-- } -->
        </tr>
        }
      </ng-template>
    </p-table>
  </div>
  }

  @if (data?.length === 0) {
  @if (!isLeaveRequest){
  <div>
    <div class="flex flex-column h-27rem surface-200 p-2 justify-content-center align-items-center">
      <div class="m-3">
        <div class="flex justify-content-center align-items-center">
          <span><i class="{{miIcons.ARCHIVED_SEARCH}} inline-block wh-80"></i></span>
        </div>
        <div>
          <p translate>{{emptyResultMsg}}</p>
        </div>
      </div>
      <div class="mb-4">
        <p class="my-0" translate>lbl_no_records_available1</p>
        <p class="flex justify-content-center" translate>lbl_no_records_available2</p>
      </div>
      <div>
        <!-- @if(label) {
        <p-button class="flex align-items-center justify-content-center btn-hide" icon="pi pi-plus" (click)="onAdd()"
          [label]="label"></p-button>
        } -->
      </div>
    </div>
  </div>
  }
  }
</div>
} @placeholder (minimum 900ms){
<app-table-skelton [isOrderHistory]="isOrderHistory"></app-table-skelton>
} @error {
<app-error-skelton></app-error-skelton>
}

<!-- @if (showBulkUpdateDialog) {
<app-bulk-update-dialog [(showBulkUpdateDialog)]="showBulkUpdateDialog" [filterFields]="filterFields"
  [bulkUpdateHeader]="bulkUpdateHeader" [reviewHeader]="reviewHeader" [btnUpdate]="btnUpdate"
  [bulkRowCount]="bulkRowCount" [entityNameForBulkUpdate]="entityNameForBulkUpdate" [attributeData]="attributeData"
  [selectedRecords]="selectedRows" (onBulkDataUpdate)="onBulkDataUpdate($event)" [entityName]="entityName"
  [entityNameToDisplay]="entityNameToDisplay" [isEntity]="isEntity"
  (onStaticBulkDataUpdate)="onStaticBulkDataUpdate($event)"
  (clearSelectedEvent)="clearSelected()"></app-bulk-update-dialog>
} -->

@if(isModal) {
<app-manage-column [isShow]="isModal" [codesToFixedInManageColumn]="codesToFixedInManageColumn"
  (onManageColumns)="onUpdateColumns($event)"
  (onToggleOverLay)="onToggle()">
</app-manage-column>
}
<p-toast></p-toast>